import { LucideIcon } from "lucide-react";

interface CalloutBoxProps {
  icon: LucideIcon;
  title: string;
  description: string;
  variant?: "green" | "dark";
}

const CalloutBox = ({ icon: Icon, title, description, variant = "green" }: CalloutBoxProps) => {
  const bg = variant === "dark"
    ? "bg-charcoal text-charcoal-foreground border-charcoal"
    : "bg-primary/5 border-primary/20 text-foreground";

  return (
    <div className={`rounded-xl border-2 p-6 mb-12 flex items-start gap-4 ${bg}`}>
      <div className="shrink-0 w-12 h-12 rounded-lg bg-primary/15 flex items-center justify-center">
        <Icon className="w-6 h-6 text-primary" />
      </div>
      <div>
        <h3 className="font-heading font-bold text-lg mb-1">{title}</h3>
        <p className={`font-body text-sm leading-relaxed ${variant === "dark" ? "text-charcoal-foreground/70" : "text-muted-foreground"}`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default CalloutBox;
